import { useFetchData } from "../hooks/useFetch";
import { Branch } from "../models/response/branch";
import { API_BRANCH_ROUTER } from "./api-config";

export const ServiceFetcher = {
  getBranchWorkingList: () => {
    const { request, baseResponse, loading } = useFetchData.Get<Branch[]>();
    return {
      fetch: (params: { status: number; key_search: string }) =>
        request({
          endPoint: API_BRANCH_ROUTER.API_GET_BRANCHES_WORKING,
          data: params,
        }),
      response: baseResponse,
      loading: loading,
    };
  },
};
